// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__KGK67","input":"SearchBar_input__bIy50","results":"SearchBar_results__noICj","item":"SearchBar_item__plclD","avatar":"SearchBar_avatar__gqZJp"};